import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';
import { useAuth } from '../../contexts/AuthContext';

const Header = ({ isCollapsed = false, userName, userRole }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [notificationCount] = useState(3);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const { userProfile, signOut } = useAuth();
  const navigate = useNavigate();

  const displayName = userName || userProfile?.full_name || userProfile?.email?.split('@')?.[0] || 'User';
  const displayRole = userRole || (userProfile?.role ? userProfile?.role?.replace('_', ' ')?.replace(/\b\w/g, c => c?.toUpperCase()) : 'Content Manager');

  const handleSearch = (e) => {
    e?.preventDefault();
    if (searchQuery?.trim()) {
      console.log('Searching for:', searchQuery);
    }
  };

  const handleNotificationClick = () => {
    console.log('Notifications clicked');
  };

  const handleSignOut = async () => {
    setShowUserMenu(false);
    await signOut();
    navigate('/login');
  };

  const getUserInitials = (name) => {
    return name?.split(' ')?.map((n) => n?.[0])?.join('')?.toUpperCase()?.slice(0, 2);
  };

  return (
    <header className={`app-header with-sidebar ${isCollapsed ? 'collapsed' : ''}`}>
      <form onSubmit={handleSearch} className="header-search">
        <Icon name="Search" size={18} />
        <input
          type="text"
          placeholder="Search content, pages, templates..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e?.target?.value)}
          className="flex-1 bg-transparent border-none outline-none text-sm text-foreground placeholder:text-muted-foreground"
        />
        {searchQuery && (
          <button
            type="button"
            onClick={() => setSearchQuery('')}
            className="text-muted-foreground hover:text-foreground transition-colors"
            aria-label="Clear search"
          >
            <Icon name="X" size={16} />
          </button>
        )}
      </form>
      <div className="header-actions">
        <button
          onClick={handleNotificationClick}
          className="header-action-button"
          aria-label="Notifications"
        >
          <Icon name="Bell" size={20} />
          {notificationCount > 0 && (
            <span className="header-action-badge">{notificationCount}</span>
          )}
        </button>

        <button className="header-action-button" aria-label="Help & Support">
          <Icon name="HelpCircle" size={20} />
        </button>

        <div className="relative">
          <div
            onClick={() => setShowUserMenu(!showUserMenu)}
            className="header-user cursor-pointer"
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e?.key === 'Enter' || e?.key === ' ') setShowUserMenu(!showUserMenu);
            }}
          >
            <div className="header-user-info">
              <div className="header-user-name">{displayName}</div>
              <div className="header-user-role">{displayRole}</div>
            </div>
            <div className="header-user-avatar">
              {getUserInitials(displayName)}
            </div>
          </div>

          {showUserMenu && (
            <>
              <div className="fixed inset-0 z-40" onClick={() => setShowUserMenu(false)} />
              <div className="absolute right-0 top-full mt-2 w-48 bg-card border border-border rounded-lg shadow-lg z-50 py-1">
                <div className="px-3 py-2 border-b border-border">
                  <p className="text-sm font-medium text-foreground truncate">{displayName}</p>
                  <p className="text-xs text-muted-foreground truncate">{userProfile?.email}</p>
                </div>
                <button
                  onClick={() => { setShowUserMenu(false); navigate('/settings-central'); }}
                  className="w-full flex items-center gap-2 px-3 py-2 text-sm text-foreground hover:bg-muted transition-colors"
                >
                  <Icon name="User" size={14} />
                  Profile Settings
                </button>
                <button
                  onClick={handleSignOut}
                  className="w-full flex items-center gap-2 px-3 py-2 text-sm text-error hover:bg-error/10 transition-colors"
                >
                  <Icon name="LogOut" size={14} />
                  Sign Out
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;